import React, { Component } from 'react';
import Autocomplete from '../autocomplete';

class DesviationTypeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      subtypes: [],
      response: {
        type: {},
        subtype: {}
      },
      currentResponse: {
        type: {},
        subtype: {}
      },
      showSubtype: true
    };
  }

  /**
   * set the state of the component if it should show the popup
   * @param {String} actionButton button action name
   */
  handleShowPopup = (actionButton) => {
    var response = this.state.response;

    // if you press the cancel button, you keep the previous filters
    if (actionButton === 'cancel') {
      response = this.state.currentResponse;
    }

    this.setState({
      showPopup: !this.state.showPopup,
      response
    });
  };

  /**
   * manages the state of the popup and sends the information
   * @param {Object} event event associated with the component that calls it
   */
  handleShowPopupAndSubmit = (event) => {
    const obj = {
      id: 'type-subtype',
      payload: this.state.response
    };

    // a copy of the response is made, in case you press the Cancel button and the previous filters must be maintained
    this.setState({
      currentResponse: {
        ...this.state.response
      }
    });

    this.props.handleSubmit(obj);
    this.handleShowPopup('apply');
  };

  /**
   * gets the subtypes associated with a type
   * @param {Object} obj object with the selected type
   */
  getSubtypesByType = (obj) => {
    const { filters } = this.props;
    let subtypes = [];

    if (obj) {
      if (obj.value !== 'TODOS' && obj.value !== 'ALL' && obj.value !== '') {
        const findType = filters.datos.types.find(item => item.key === obj.value);
        subtypes = (findType) ? findType.subtypes : [];
      }
    }

    this.setState({
      subtypes,
      response: {
        type: obj,
        subtype: {}
      },
      // hide the Subtype combo for a few milliseconds so it will re-render
      showSubtype: false
    });

    // re-renders the combo Subtype
    setTimeout(() => {
      this.setState({
        showSubtype: true
      });
    }, 100);
  }

  /**
   * set the selected subtype to the component state
   * @param {Object} obj object with selected subtype
   */
  setSubtypes = (obj) => {
    this.setState({
      response: {
        ...this.state.response,
        subtype: obj
      }
    });
  }

  /**
   * gets information of the selected type
   * @returns object with the selected name and type
   */
  getTypeName = () => {
    let name = '';
    let findType = null;

    // gets the name of the Type if a filter has already been done
    if (this.props.filters.datos && this.props.filters.type) {
      // If I already select some type of the combo, it uses the data of the state, otherwise it uses the data of the reducer
      if (this.state.response.type.value) {
        findType = this.props.filters.datos.types.find(item => item.key === this.state.response.type.value);
      } else {
        findType = this.props.filters.datos.types.find(item => item.key === this.props.filters.type);
      }

      if (findType) {
        name = findType.value;
      }
    }

    return {
      name,
      type: findType
    };
  }

  /**
   * get name of selected subtype
   * @returns name of the selected subtype
   */
  getSubtypeName = () => {
    let name = '';
    let findSubtype;
    const { type: findType } = this.getTypeName();

    // gets the name of the Subtype if a filter has already been done
    if (findType && this.state.response.type !== 'TODOS' && this.state.response.type !== 'ALL' && this.state.response.type !== '') {
      if (this.state.response.subtype.value) {
        findSubtype = findType.subtypes.find(item => item.key === this.state.response.subtype.value);
      } else {
        findSubtype = findType.subtypes.find(item => item.key === this.props.filters.subtype);
      }

      if (findSubtype) {
        name = findSubtype.value;
      }
    }

    return name;
  }

  render() {
    const {
      language,
      filters
    } = this.props;

    const { name: typeName } = this.getTypeName();
    const subtypeName = this.getSubtypeName();

    let selectedFiltersText = '';
    selectedFiltersText += (typeName.length > 0) ? `${language.filter.type}: ${typeName}` : '';
    selectedFiltersText += (subtypeName.length > 0) ? `, ${language.filter.subtype}: ${subtypeName}` : '';
    selectedFiltersText = selectedFiltersText === '' ? language.all : selectedFiltersText;

    return (
      <div className="multiple-tags-input">
        <div className="multiple-tags-input-main-input-wrapper">
          <div className="multiple-tags-input-main-input-label-wrapper">
            <label>{language.filter.typeFilters}</label>
          </div>
          <div>
            <div 
              title={selectedFiltersText}
              className={`multiple-tags-input-main-input ${this.props.filterClassName || ''}`}
              onClick={() => this.handleShowPopup('')}
            >
              {selectedFiltersText}
            </div>
          </div>
        </div>
        {
          this.state.showPopup && (
            <div onClick={() => this.handleShowPopup('')} className="multiple-tags-input-popup-glass-panel"/>
          )
        }
        <div 
          className={"multiple-tags-input-popup-wrapper small-wrapper " + (!this.state.showPopup ? "hide-popup" : "")}
        >
          <div  className="multiple-tags-input-popup-inner-wrapper">
            <div className="multiple-tags-input-popup-inputs-container">
              <div className="multiple-tags-input-popup-inputs-container-slice">
                <div className="box-form islabel box170">
                  <div>
                    <label>{language.filter.type}</label>
                  </div>
                  <div>
                    <Autocomplete
                      value={typeName.length > 0 ? typeName : language.all}
                      save={language.all}
                      id={`type`}
                      alias="value"
                      select="key"
                      idItem="key"
                      filter={filters.datos ? filters.datos.types : []}
                      handleSubmit={(obj) => { this.getSubtypesByType(obj) }}
                    />
                  </div>
                </div>
                <div className="box-form islabel box170">
                  <div>
                    <label>{language.filter.subtype}</label>
                  </div>
                  <div>
                    {
                      this.state.showSubtype && (
                        <Autocomplete
                          value={subtypeName.length > 0 ? subtypeName : language.all}
                          save={language.all}
                          id={`subtype`}
                          alias="value"
                          select="key"
                          idItem="key"
                          filter={this.state.subtypes}
                          handleSubmit={(obj) => {this.setSubtypes(obj)}}
                        />
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="multiple-tags-input-popup-buttons-container">
              <div className="big-button cancel-button" onClick={() => this.handleShowPopup('cancel')}>
                {language.filter.cancel}
              </div>
              <div className="big-button" onClick={this.handleShowPopupAndSubmit}>
                {language.filter.apply}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DesviationTypeInput;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/desviationTypeInput.jsx